module.exports = __webpack_public_path__ + "img/Pferdefachfrau-FB-117.cdf00653.jpg";